import React from 'react';

import classnames from 'classnames';

const Key = ({ text, value, color, large }) => (
  <div
    className={classnames(
      'flex-column',
      large ? 'dashboard-chart-key-large' : 'dashboard-chart-key',
    )}
  >
    <div className="flex-row flex-align-center">
      <span
        className={classnames(
          large ? 'dashboard-chart-dot-large' : 'dashboard-chart-dot',
        )}
        style={{ backgroundColor: color }}
      />
      <p>
        {text} ({value})
      </p>
    </div>
  </div>
);

const ChartKeys = ({ data, column, large }) => (
  <div
    className={classnames(
      'dashboard-keys',
      'flex-expand',
      'flex-space-around',
      column ? 'flex-column' : 'flex-row',
    )}
  >
    {data.map((key) => (
      <Key
        key={key.title}
        text={key.title}
        value={key.value}
        large={large}
        color={key.color}
      />
    ))}
  </div>
);

export default ChartKeys;
